import { Modal, Button, Text, Group, ThemeIcon, Stack, Flex } from "@mantine/core";
import IconTrash from "@tabler/icons-react/dist/esm/icons/IconTrash.mjs";
import IconAlertTriangle from "@tabler/icons-react/dist/esm/icons/IconAlertTriangle.mjs";

export function DeleteConfirmModal({ opened, onClose, label, onDelete }) {
  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      radius="md"
      size="sm"
      title={
        <Flex gap="sm" direction="row" align="center">
          <ThemeIcon color="red" variant="light" size="lg" radius="xl">
            <IconAlertTriangle size={18} />
          </ThemeIcon>
          <Text span fw={600} c="var(--mantine-color-text)">
            {label}
          </Text>
        </Flex>
      }
    >
      <Stack gap="lg">
        <Text size="md" fw={500} ta="center" c="var(--mantine-color-text)">
          This action cannot be undone!
        </Text>

        <Group justify="space-between" gap="sm">
          <Button variant="default" onClick={onClose} radius="md">
            Cancel
          </Button>
          <Button
            color="red"
            leftSection={<IconTrash size={16} />}
            onClick={handleDelete}
            radius="md"
          >
            Confirm
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

// --- Usage Example ---
// import { useDisclosure } from "@mantine/hooks";
//
// function App() {
//   const [opened, { open, close }] = useDisclosure(false);
//
//   const handleDelete = () => {
//     console.log("Item deleted!");
//     // your delete logic here
//   };
//
//   return (
//     <>
//       <Button color="red" onClick={open}>Delete Item</Button>
//       <DeleteConfirmModal
//         opened={opened}
//         onClose={close}
//         label="My Important File"
//         onDelete={handleDelete}
//       />
//     </>
//   );
// }
